/**
 * The global friendship document `friendships/{uidA}_{uidB}` — what a friend
 * request writes and what its acceptance changes. Every writer and reader of
 * the id goes through here: the client (`useFriendships`), the Spraywall
 * viewer-key Functions (`apps/functions/src/sprayViewerKeys.js`) and the E2E
 * seed (tests/e2e/seed/). docs/spec/13-settings.md "Friends section".
 *
 * `firestore.rules` holds the contract: a create is `pending`, `requestedBy`
 * the writer, with both uids in `users`; an update only moves it to `accepted`
 * with an `acceptedAt`, by the other party; either party may delete it (a
 * rejected, revoked or removed friendship leaves no document).
 */

/** The friendship's id: the two uids sorted, joined by `_`. */
export function friendshipId(uidA, uidB) {
  const [a, b] = [uidA, uidB].sort();
  return `${a}_${b}`;
}

/**
 * A new request from `fromUid` to `toUid`.
 * @param {*} requestedAt  an SDK timestamp or sentinel — the caller's (this module is SDK-free)
 */
export function buildFriendRequestDoc({ fromUid, toUid, requestedAt }) {
  return {
    users: [fromUid, toUid].sort(),
    status: "pending",
    requestedBy: fromUid,
    requestedAt,
    acceptedAt: null,
  };
}

/**
 * The update the other party's acceptance writes.
 * @param {*} acceptedAt  an SDK timestamp or sentinel — the caller's
 */
export function buildFriendAcceptPatch({ acceptedAt }) {
  return { status: "accepted", acceptedAt };
}
